import { Fragment } from "react";
import { Box, Skeleton } from "@mui/material";

interface Prop {
  simple?: boolean;
}

export default function CSkeleton({ simple }: Prop) {
  return (
    <Fragment>
      <Box alignSelf={{ xs: "flex-start", md: "center" }}>
        <Skeleton width="50%" height={"3.5rem"} sx={{ mt: 2 }} />
        <Skeleton width="75%" height={"2rem"} />
        <Skeleton width="95%" height={"2rem"} />
        <Skeleton width="85%" height={"2rem"} />
        <Skeleton width="100%" height={"2rem"} />
        {!simple && (
          <>
            <Skeleton width="50%" height={"3.5rem"} sx={{ mt: 2 }} />
            <Skeleton width="75%" height={"2rem"} />
            <Skeleton width="95%" height={"2rem"} />
            <Skeleton width="85%" height={"2rem"} />
            <Skeleton width="100%" height={"2rem"} />
            <Skeleton width="50%" height={"3.5rem"} sx={{ mt: 2 }} />
            <Skeleton width="75%" height={"2rem"} />
            <Skeleton width="95%" height={"2rem"} />
            <Skeleton width="85%" height={"2rem"} />
            <Skeleton width="100%" height={"2rem"} />
          </>
        )}
      </Box>
    </Fragment>
  );
}
